<template>
    <div>
        <div class="layout-right bg mb16">
            <Form :label-width="98">
                <Row :gutter="24">
                    <Col span="8">
                        <Form-item label="投保公司">
                            <Input v-model.trim="params.applicantInfo" clearable placeholder="请输入投保公司" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="保单编号">
                            <Input v-model.trim="params.cntrNo" clearable placeholder="请输入保单编号" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="保单状态">
                            <Select v-model="params.effectiveStatus" clearable>
                                <Option v-for="(item,index) in list" :value="item.value" :key="index">{{ item.label }}</Option>
                            </Select>
                        </Form-item>
                    </Col>
                </Row>
                <Row>
                    <Col span="24" class="right">
                        <Button type="primary" @click="tabChange">搜索</Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <div class="layout-right bg">
            <i-table :columns="columns" url="/broker/insurance/policy/list.json" :params="params" ref="table">
                <template slot-scope="{ row }" slot="cntrNo">
                    {{ row.cntrNo?row.cntrNo:row.guaranteeNo }}
                </template>
                <template slot-scope="{ row }" slot="action">
                    <Dropdown transfer>
                        <a href="javascript:void(0)">
                            管理
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <Dropdown-menu slot="list">
                            <Dropdown-item @click.native="toDetail(row)" style="text-align: center;">
                                <a>查看详情</a>
                            </Dropdown-item>
                            <Dropdown-item style="text-align: center;">
                                <a @click="downPolicy(row)">下载电子保单</a>
                            </Dropdown-item>
                            <!-- 暂无此功能
                            <Dropdown-item style="text-align: center;">
                                <a @click="toInvoice(row)">修改发票</a>
                            </Dropdown-item>
                            <Dropdown-item style="text-align: center;">
                                <a @click="uploadForm(row)">补录投保单</a>
                            </Dropdown-item> -->
                        </Dropdown-menu>
                    </Dropdown>
                    <!-- <a v-if="row.effectiveStatus=='REVIEWING'" class="ml5" @click="toRest(row)">批单</a> -->
                </template>
            </i-table>
        </div>
        <Modal v-model="invoiceShow" title="发票信息" width="600px" :mask-closable="false" @on-cancel="cancalInvoice">
			<Form :model="invoiceForm" ref="invoiceForm" :label-width="105" :rules="invoiceFormRules">
                <FormItem label="发票信息" prop="invoiceType">
					<RadioGroup v-model="invoiceForm.invoiceType" @on-change="radioChange">
                        <Radio label="PLAIN">普票（电子）</Radio>
                        <Radio label="VAT">专票（纸质）</Radio>
                    </RadioGroup>
				</FormItem>
				<FormItem label="公司名称" prop="invoiceName" :rules="invoiceFormRules.invoiceName">
					<Input type="text"  v-model="invoiceForm.invoiceName" :maxlength="250"></Input>
				</FormItem>
				<FormItem label="统一社会信用代码" prop="invoiceUniqueCode" :rules="invoiceFormRules.invoiceUniqueCode">
					<Input type="text" v-model="invoiceForm.invoiceUniqueCode" :maxlength="250"></Input>
				</FormItem>
				<FormItem label="开户地址" prop="invoiceAddress" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoiceAddress: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.invoiceAddress" placeholder="请输入开户地址" :maxlength="50"></Input>
				</FormItem>
				<FormItem label="联系电话" prop="invoicePhone" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoicePhone: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.invoicePhone" placeholder="请输入联系电话" :maxlength="20"></Input>
				</FormItem>
                <FormItem label="开户行" prop="openingBankName" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.openingBankName: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.openingBankName" placeholder="请输入开户行" :maxlength="30"></Input>
				</FormItem>
                <FormItem label="对公账号" prop="openingBankAccount" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.openingBankAccount: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.openingBankAccount" placeholder="请输入对公账号" :maxlength="30"></Input>
				</FormItem>
                <FormItem label="电子邮箱" prop="invoiceDeliverEmail" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoiceDeliverEmail: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.invoiceDeliverEmail" placeholder="请输入电子邮箱" :maxlength="100"></Input>
				</FormItem>
                <FormItem label="邮寄地址" prop="invoiceDeliverAddress" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoiceDeliverAddress: [{ required: false }]">
					<Input type="text" placeholder="填写内容需要包含邮寄人姓名、电话与邮寄地址" v-model="invoiceForm.invoiceDeliverAddress" :maxlength="100"></Input>
				</FormItem>
			</Form>
			<template slot="footer">
				<Button type="text" @click="cancalInvoice">取消</Button>
				<Button type="primary" @click="handleSubmit('invoiceForm')">确定</Button>
			</template>
		</Modal>
        <Modal
            v-model="modal"
            title="上传投保单"
        >
            <Form :label-width="100" class="mt15">
                <FormItem label="盖章投保单：">
                    <Form class="policy" :model="form" ref="supplementForm" :label-width="0">
                        <Form-item 
                            class="policy-item" 
                            v-for="(p,i) in form.fileList"
                            :prop="'fileList.' + i + '.fileUrl'"
                            :key="i"
                            :rules="{required:true,message:'请上传投保单',trigger:'change'}">
                            <UploadImg 
                                v-model="p.fileUrl" 
                                @on-remove="removeImg(i)"
                                @on-success="val=>{uploaded(val, i)}"
                                :show-del="form.fileList.length>1" />
                            <Input v-model="p.fileUrl" v-show="false"></Input>
                        </Form-item>
                        <div class="policy-item" v-if="form.fileList.length<15">
                            <a @click="add">添加投保单</a>
                        </div>
                    </Form>
                </FormItem>
            </Form>
            <template slot="footer">
				<Button type="text" @click="cancel">取消</Button>
				<Button type="primary" @click="supplementSubmit">确定</Button>
			</template>
        </Modal>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import ITable from '../../../companyGroupEmployerDadi/common/ITable'
    import UploadImg from '../../../companyGroupEmployerDadi/common/UploadImg'
    export default {
        components:{ ITable, UploadImg },
        data () {
            return {
                loading: false,
                params: {
                    bizId:'INDUSTRY_ENTERPRISE',
                    effectiveStatus: '',
                    cntrNo: ''
                },
                columns: [
                    {title:'保单编号',slot:'cntrNo',width: 180,fixed: 'left',render: (h, params) => {
                        return h('div', [h('Tooltip', {
                            props: {
                                placement: 'top',
                                transfer: true
                            }},[h('span', {
                                style: {
                                    display: 'inline-block',
                                    width: '160px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }
                            }, params.row.cntrNo?params.row.cntrNo:params.row.guaranteeNo),h('span',{
                                slot:'content',
                                style:{
                                    whiteSpace:'normal'
                                }
                            },params.row.cntrNo?params.row.cntrNo:params.row.guaranteeNo)])
                        ]);  
                    }},
                    {title:'保单创建时间',key:'createTime',width: 180},
                    {title:'投保公司名称',key:'applicantName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'产品名称',key:'productName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'保单状态',key:'effectiveStatusDesc',width: 120},
                    {title:'保费（元）',key:'premium',width: 120,align: 'right'},
                    {title:'保障起期',key:'effectiveDateStart',width: 120},
                    {title:'保障止期',key:'effectiveDateEnd',width: 120},
                    {
                        title: '操作',
                        slot: 'action',
                        width: 90,
                        align: 'center',
                        fixed: 'right'
                    }
                ],
                list:[
                    {
                        value: 'EFFECTIVE',
                        label: '保障中'
                    },
                    {
                        value: 'EXPIRED',
                        label: '已过期'
                    },
                    {
                        value: 'TO_BE_EFFECTIVE',
                        label: '待生效'
                    }
                ],
                invoiceShow:false,
                insurancePolicyId:'',
                invoiceForm:{
                    invoiceType:'PLAIN'
                },
                invoiceFormRules:{
                    invoiceName:{required:true,message:'请输入开票名称',trigger:'blur'},
                    invoiceUniqueCode:{required:true,message:'请输入统一社会信用代码',trigger:'blur'},
                    invoiceAddress:{required:true,message:'请输入开户地址',trigger:'blur'},
                    invoicePhone:{required:true,message:'请输入联系电话',trigger:'blur'},
                    openingBankName:{required:true,message:'请输入开户行',trigger:'blur'},
                    openingBankAccount:{required:true,message:'请输入对公账号',trigger:'blur'},
                    invoiceDeliverEmail:[
                        { required: true, message: '邮箱不能为空', trigger: 'blur' },
                        { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
                    ],
                    invoiceDeliverAddress:{required:true,message:'请输入邮寄地址',trigger:'blur'}
                },
                modal:false,
                form:{
                    fileList:[{
                        fileUrl:''
                    }]
                }
            }
        },
        computed:{
            ...mapState({
                channelId: state=>state.common.channelInfo.id,
            })
        },
        created () {
            // this.getList()
        },
        methods:{
            uploadForm(row){
                this.modal = true;
                this.$refs.supplementForm.resetFields();
                this.$nextTick(()=>{
                    this.form = this.jsonCopy(row);
                    this.$set(this.form,'fileList',[{
                        fileUrl:''
                    }])
                })
            },
            removeImg (i) {
                this.form.fileList.splice(i,1);
            },
            uploaded(file, index){
                let obj = {
                    fileUrl:file.url,
                    fileName:file.name,
                    fileType:'APPLICATION'
                }
                this.$set(this.form.fileList, index, obj);
            },
            add () {
                this.form.fileList.push({
                    fileUrl:''
                })
            },
            cancel(){
                this.modal = false;
                this.form = {
                    fileList:[{
                        fileUrl:''
                    }]
                }
            },
            async supplementSubmit(){
                let flag = await this.$refs.supplementForm.validate();
                if(!flag){
                    this.toast('请上传投保单','error');
                    return
                }
                this.$axios.post('/broker/attachment/uploadAttachmentFile.json.all',{
                    bizId:this.form.bizId,
                    productCode:this.form.productCode,
                    applicationId:this.form.insuranceApplicationId,
                    fileList:this.form.fileList
                }).then(res=>{
                    this.$Message.success('上传成功')
                    this.cancel();
                    this.tabChange();
                })
            },
            radioChange(val){
                this.$set(this.invoiceForm,'invoiceType',val)
            },
            downPolicy(row){
                this.$axios.post('/broker/insurance/policy/getPolicyUrl.json',{
                    insurancePolicyId: row.insurancePolicyId
                }).then(res=>{
                    const newPage = window.open(); // 打开一个不被拦截的空白窗口
                    newPage.location.href = res // 修改空白窗口的url
                })
            },
            handleSubmit (name) {
                if(this.invoiceForm.invoiceType=='VAT'){
                    this.$refs[name].validate((valid) => {
                        if (valid) {
                            this.$axios.post('/broker/insurance/policy/editInvoice.json',{
                                insurancePolicyId:this.insurancePolicyId,
                                invoiceInfo: this.invoiceForm
                            }).then(res=>{
                                this.$Message.success('申请成功!');
                                this.cancalInvoice()
                                this.tabChange()
                            }).catch(err=>{
                                this.cancalInvoice()
				            })
                        }
                    })
                } else {
                    let reg=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                    if(this.invoiceForm.invoiceDeliverEmail&&(this.invoiceForm.invoiceDeliverEmail!==''&&!reg.test(this.invoiceForm.invoiceDeliverEmail))) { 
                        this.$Message.error('请输入有效的邮箱');
                        return
                    }
                    this.$refs[name].validate((valid) => {
                        if (valid) {
                            this.$axios.post('/broker/insurance/policy/editInvoice.json',{
                                insurancePolicyId:this.insurancePolicyId,
                                invoiceInfo: this.invoiceForm
                            }).then(res=>{
                                this.$Message.success('申请成功!');
                                this.cancalInvoice()
                                this.tabChange()
                            })
                        }
                    })
                }
            },
            cancalInvoice(){
                this.invoiceShow = false;
                this.insurancePolicyId = ''
                this.invoiceForm = {
                    invoiceType:'PLAIN'
                }
            },
            toInvoice(row){
                this.invoiceShow = true;
                this.insurancePolicyId = row.insurancePolicyId;
                if(row.invoiceInfo.invoiceType!='NOT'){
                    this.$nextTick(()=>{
                        this.invoiceForm = this.jsonCopy(row.invoiceInfo);
                        // this.$set(this.invoiceForm,'invoiceName',row.applicantList[0].subjectName);
                        // this.$set(this.invoiceForm,'invoiceUniqueCode',row.applicantList[0].idNumber);
                        // this.$set(this.invoiceForm,'orderNo',row.orderNo);
                    })
                }
            },
            tabChange(){
                this.$refs.table.getList()
            },
            toDetail(row){
                this.$router.push({
                    path:`/my/customizedCCIC/policyDetail/${row.cntrNo?row.cntrNo:row.guaranteeNo}`
                })
            }
        }
    }
</script>
<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/policy/index.vue